// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-34VYa","title":"index-title-2pAKD","content":"index-content-2bnDq"};